import { useExchangeStore } from '@app/hooks/trade/exchangeStore';
import React, { useContext } from 'react';
import { TradeText } from './styles';
import { useNavigate } from 'react-router-dom';
import { Text } from '@/styles/reactnative';
import { useTranslation } from 'react-i18next';
import { COLORS } from '@app/constants';
import useTradeStore from '@app/hooks/trade/tradeStore.tsx';
import { useDemoTradingStore } from '@app/hooks/trade/demoTradingStore';
import styled from 'styled-components';
import { ThemeContext } from '@/theme/ThemeProvider';

const ContractsColumn = ({ item }) => {
  const { t } = useTranslation();
  const { mutate } = useTradeStore();
  const { EPs } = useExchangeStore();
  const navigate = useNavigate();
  const { isDemoMode } = useDemoTradingStore();
  const { isDarkMode } = useContext(ThemeContext);

  const EP = EPs?.find((item2: any) => +item2.id == +item?.exchange_pairs_id);
  const isLong = item?.long_short === 'L';
  const borderColor = isLong ? COLORS.lightGreen : COLORS.lightRed;

  return (
    <Container
      $borderColor={borderColor}
      onClick={() => {
        if (EP) {
          mutate({
            ep_id: EP.id,
            ...EP,
          });
          const basePath = isDemoMode ? '/demo-trade' : '/trade';
          navigate(`${basePath}/${EP.id}`, { replace: true });
        }
      }}
    >
      <PairsText>{EP?.pairs}</PairsText>
      <TagsRow>
        <Tag $color={borderColor} $isDarkMode={isDarkMode}>
          {isLong ? t('long') : t('short')}
        </Tag>
        <Tag $color="#888" $isDarkMode={isDarkMode}>
          {item?.cross_iso === 'C' ? t('cross') : t('iso')}
          {item?.leverage}X
        </Tag>
      </TagsRow>
    </Container>
  );
};

const Container = styled.div<{ $borderColor: string }>`
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding-left: 8px;
  border-left: 3px solid ${({ $borderColor }) => $borderColor};
  cursor: pointer;
  font-family: 'NanumSquareRound', sans-serif;

  &:hover {
    opacity: 0.8;
  }
`;

const PairsText = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.COLORS?.textw || '#fff'};
  letter-spacing: 0.3px;
`;

const TagsRow = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
`;

const Tag = styled.span<{ $color: string; $isDarkMode: boolean }>`
  font-size: 10px;
  font-weight: 500;
  padding: 1px 4px;
  border-radius: 2px;
  background: ${({ $color, $isDarkMode }) =>
    $isDarkMode ? `${$color}20` : `${$color}15`};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;

export default React.memo(ContractsColumn);
